import { useCallback, useEffect, useState } from "react"
import { useToast } from "./index"

const mappedImages = (gallery) => {
  return (
    gallery?.map((img, index) => ({
      id: `${new Date().getTime()}_${index}`,
      name: "",
      type: "",
      uri: img.name,
      uploaded: true,
      deleted: false,
    })) || []
  )
}

export const useSelectImages = (gallery) => {
  const [selectedImages, setSelectedImages] = useState(
    mappedImages(gallery || [])
  )

  useEffect(() => {
    if (!gallery.length) return
    setSelectedImages(mappedImages(gallery || []))
  }, [gallery])

  const handleImageSelect = useCallback(
    (event) => {
      const images = event.target.files
      if (images) {
        const currentImageCount = selectedImages.filter(
          (img) => !img.deleted
        ).length
        const availableSlots = 8 - currentImageCount

        if (images.length > availableSlots) {
          useToast("error", "Maximum limit reached")
        }

        const newImagesArray = Array.from(images)
          .slice(0, availableSlots)
          .map((image, index) => ({
            id: `${new Date().getTime()}_${index}`,
            name: "galleryImage",
            type: image.type,
            uri: image,
            uploaded: false,
            deleted: false,
          }))

        setSelectedImages((prevImages) => [...prevImages, ...newImagesArray])
      }
    },
    [selectedImages]
  )

  const handleImageDeselect = useCallback((id) => {
    setSelectedImages((prevSelectedImages) => {
      return prevSelectedImages
        .map((photo) => {
          if (photo.id === id) {
            if (photo.uploaded) {
              return { ...photo, deleted: true }
            } else {
              return null // Filter out the image if not uploaded
            }
          }
          return photo
        })
        .filter(Boolean) // Remove null entries from the array
    })
  }, [])

  return {
    selectedImages,
    setSelectedImages,
    handleImageSelect,
    handleImageDeselect,
  }
}
